import type { CallOfferEvent } from '@/services/chatSocket'

export type RingingCallsAction =
  | { type: 'offer'; call: CallOfferEvent }
  | { type: 'remove'; callId: string }
  | { type: 'clear' }

export function ringingCallsReducer(
  state: CallOfferEvent[],
  action: RingingCallsAction,
): CallOfferEvent[] {
  switch (action.type) {
  case 'offer': {
    const index = state.findIndex((call) => call.callId === action.call.callId)
    if (index === -1) return [...state, action.call]
    return state.map((call, i) => (i === index ? action.call : call))
  }
  case 'remove':
    if (!state.some((call) => call.callId === action.callId)) return state
    return state.filter((call) => call.callId !== action.callId)
  case 'clear':
    return state.length === 0 ? state : []
  }
}
